module.exports = __webpack_public_path__ + "img/add-candidate-succes.2dca8a3f.svg";